export default __webpack_public_path__ + "static/media/sharpTurn.0ae69e69.png";